import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const AgreementSelect = ({ value, onChange, testid = "referido-acuerdo-select" }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/red/acuerdos").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  if (!items) return null;
  return (
    <select data-testid={testid} className="c-input text-sm" value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">Sin acuerdo de comisión</option>
      {items.map((a) => <option key={a.id} value={a.id}>{a.negocio} · {a.modalidad.replaceAll("_", " ")}</option>)}
    </select>
  );
};

export const ReferidoPrompt = ({ s, onDone }) => {
  const [ag, setAg] = useState("");
  const [busy, setBusy] = useState(false);
  if (s.referido_id) return (
    <Link to={`/conecta/negocios/${s.referido_id}`} data-testid="referido-link" className="c-card p-4 block text-sm font-semibold c-accent">Ver referido en Negocios →</Link>
  );
  const save = async () => {
    setBusy(true);
    try { await api.post(`/red/solicitudes/${s.id}/referido`, { comision_acuerdo_id: ag || null }); toast.success("Referido registrado en tu pipeline"); onDone(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="referido-prompt" className="c-card p-4 space-y-2.5 border-[#bc9538]/50">
      <p className="font-semibold">¿Registrar como referido?</p>
      <p className="text-xs c-text-2">Se crea en tu pipeline con origen red, y {s.solicitante.nombre_publico} lo verá como “Recibido de ti”.</p>
      <AgreementSelect value={ag} onChange={setAg} />
      <button data-testid="referido-save-btn" disabled={busy} onClick={save} className="c-btn-primary w-full py-2.5 flex items-center justify-center gap-2">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Registrar referido</button>
    </div>
  );
};
